/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { RouterEffects } from './router.effect';

export const effects: any[] = [RouterEffects];

export * from './router.effect';
